import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BusquedaEncuesta } from './model/BusquedaEncuesta';
import { EncuestaService } from './service/encuesta.service';
import { Encuesta, EncuestaGuardar, EncuestaView, RespuestaEncuesta } from './model/Encuesta';
import { AuthService } from 'src/app/core/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { TokenUserData } from 'src/app/core/models/accessToken';
import { GenericToasterService } from 'src/app/core/services/generic-toaster.service';
import { GoogleAnalyticsEventsService } from '../../core/services/google-analytics-events.service';

@Component({
  selector: 'app-encuesta',
  templateUrl: './encuesta.component.html',
  styleUrls: ['./encuesta.component.scss']
})
export class EncuestaComponent implements OnInit, OnDestroy {
  @Input() aliasEncuesta: string = '';
  @Input() resourceKeyPantalla: string = '';
  @Input() retardoEnSegundos: number = 0;

  encuesta: Encuesta;
  respuestaEncuesta: RespuestaEncuesta;
  encuestaContestada: boolean = false;
  userData: TokenUserData;

  private messageHandler: any;

  constructor(
    private servicioEncuesta: EncuestaService,
    private authService: AuthService,
    private cookieService: CookieService,
    private genericToasterService: GenericToasterService,
    private googleAnalyticsEventsService: GoogleAnalyticsEventsService
  ) { }

  async ngOnInit(): Promise<void> {
    if (!this.authService.esPlanexware()) {
      const retardoEnMilisegundos = this.retardoEnSegundos * 1000;

      //Se visualiza la encuesta despues de unos segundos
      setTimeout(async () => {
        const userData = this.authService.getUserData();
        if (userData) {
          this.userData = userData;
          const parametros: BusquedaEncuesta = new BusquedaEncuesta(this.aliasEncuesta, this.resourceKeyPantalla, userData?.Id, userData?.IdPais, userData?.Cliente.Id, userData?.Cliente.IdPais);
          const datosEncuesta: EncuestaView = await this.servicioEncuesta.RecuperarEncuesta(parametros);

          // Si trae datos de la encuesta quiere decir que el usuario la puede completar
          if (datosEncuesta.encuesta != null) {
            this.encuesta = datosEncuesta.encuesta;
            this.respuestaEncuesta = datosEncuesta.respuestaEncuesta;

            this.eliminarSurveyMonkeyCookie();
            this.cargarSurveyMonkeyScript();
            this.setearSurveyMonkeyMessageEvents();
          }
        }
      }, retardoEnMilisegundos);
    }
  }

  eliminarSurveyMonkeyCookie() {
    const cookies = this.cookieService.getAll();
    const surveyMonkeyCookieKey = Object.keys(cookies).find(
      (key) => key.startsWith('smcx_') && key.endsWith('_last_shown_at')
    );

    if (surveyMonkeyCookieKey) {
      this.cookieService.delete(surveyMonkeyCookieKey, '/');
    }
  }

  cargarSurveyMonkeyScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = this.encuesta.urlEncuesta;

    script.onload = async () => {
      await this.guardarRespuestaEncuesta(this.encuestaContestada);
      this.googleAnalyticsEventsService.emitEvent(this.aliasEncuesta, 'Visualizacion', this.userData.Email, true);
    };

    const sdkElement = document.getElementById("smcx-sdk");
    if (sdkElement) {
      sdkElement.appendChild(script);
    }
  }

  setearSurveyMonkeyMessageEvents() {
    // Existe un evento que se dispara cuando aparece la pantalla de agradecimiento, luego de haber finalizado una encuesta
    // Se escucha este evento para saber si el usuario contesto o no
    this.messageHandler = async (event: MessageEvent) => {
      if (event.origin === 'https://www.surveymonkey.com' && event.data.includes('sm:thank_you_page_loaded')) {
        this.encuestaContestada = true;
        await this.guardarRespuestaEncuesta(this.encuestaContestada);
        this.googleAnalyticsEventsService.emitEvent(this.aliasEncuesta, 'Respuesta', this.userData.Email, true);
      }
    };

    window.addEventListener('message', this.messageHandler);
  }

  async guardarRespuestaEncuesta(complete: boolean) {
    const respuestaAGuardar: EncuestaGuardar = {
      idConfiguracionEncuesta: this.encuesta.idConfiguracionEncuesta,
      aliasEncuesta: this.encuesta.aliasEncuesta,
      idRespuestaEncuesta: this.respuestaEncuesta ? this.respuestaEncuesta.id : null,
      fechaUltimaVisualizacion: new Date(),
      fechaCompletada: complete ? new Date() : null,
      resourceKeyPantalla: this.resourceKeyPantalla,
      idUsuario: this.userData.Id,
      idPaisUsuario: this.userData.IdPais,
      idCliente: this.userData.Cliente.Id,
      idPaisCliente: this.userData.Cliente.IdPais,
      versionRegistro: this.respuestaEncuesta ? this.respuestaEncuesta.versionRegistro : null,
    };

    const result = await this.servicioEncuesta.GuardarRespuestaEncuesta(respuestaAGuardar);
    if (result.isFailed) {
      this.genericToasterService.pushError(result.reasons[0].message);
    }
    else {
      const respuesta = result.value;
      this.respuestaEncuesta = {
        id: respuesta.id,
        versionRegistro: respuesta.versionRegistro
      };
    }
  }

  async ngOnDestroy() {

    if (this.encuesta) {
      if (this.messageHandler) window.removeEventListener('message', this.messageHandler);

      // Elimina la ventana emergente de SurveyMonkey si está presente
      const surveyMonkeyModal = document.querySelector('.smcx-modal');
      if (surveyMonkeyModal) {
        surveyMonkeyModal.remove();
      }

      // Elimina también el script de SurveyMonkey si es necesario
      const surveyMonkeyScript = document.querySelector('script[src*="surveymonkey"]');
      if (surveyMonkeyScript) {
        surveyMonkeyScript.remove();
      }
    }
  }


}
